// tslint:disable:no-null-keyword
import * as React from "react";
import { IdStyles } from "../../../../../less/IdStyles";
import { Badge } from "../../../../generic/badge/Badge";
import { IdBadgePosition } from "../../../../generic/badge/IdBadgePosition";
import { Icon } from "../../../../generic/icon/Icon";
import { IdIcon } from "../../../../generic/icon/IdIcon";
import { TextLoca } from "../../../../generic/text/TextLoca";
import { TextLocaValueProportional } from "../../../../generic/text/TextLocaValueProportional";
export var QuestTask = function (_a) {
    var currentAmount = _a.currentAmount, requiredAmount = _a.requiredAmount, locaKey = _a.locaKey, locaReplacements = _a.locaReplacements, taskCompleted = _a.taskCompleted, icon = _a.icon, children = _a.children;
    var taskBackground = taskCompleted
        ? IdStyles.QuestTaskFinishedBackground
        : IdStyles.QuestTaskBackground;
    var badge = taskCompleted && (React.createElement(Badge, { position: IdBadgePosition.TopRight },
        React.createElement(Icon, { icon: IdIcon.QuestFinishIcn, styleId: IdStyles.IconLarge })));
    var amount = taskCompleted ? requiredAmount : currentAmount;
    return (React.createElement("div", { className: "flex flex--aligned flex--stacked quest-item-task " + taskBackground },
        React.createElement("div", { className: "flex flex--stacked flex--aligned task-icon" },
            badge,
            icon,
            React.createElement("div", { className: "" + IdStyles.TextBoldAccent },
                React.createElement(TextLocaValueProportional, { available: amount, required: requiredAmount }))),
        React.createElement("div", { className: "flex flex--centered flex--top task-description " + IdStyles.TextNormal },
            React.createElement(TextLoca, { id: locaKey, replacements: locaReplacements })),
        React.createElement("div", { className: "flex flex--around flex--bottom w100 task-buttons" }, children)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/tasks/QuestTask.tsx
// module id = 117
// module chunks = 3